var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "currentcolor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12C15.3125 12 16 11.3438 16 10.5V1.5C16 0.6875 15.3125 0 14.5 0H1.5C0.65625 0 0 0.6875 0 1.5V10.5C0 11.3438 0.65625 12 1.5 12H14.5ZM3.5 1.75C4.4375 1.75 5.25 2.5625 5.25 3.5C5.25 4.46875 4.4375 5.25 3.5 5.25C2.53125 5.25 1.75 4.46875 1.75 3.5C1.75 2.5625 2.53125 1.75 3.5 1.75ZM2 10V8.5L4.21875 6.28125C4.375 6.125 4.59375 6.125 4.75 6.28125L6.5 8L10.7188 3.78125C10.875 3.625 11.0938 3.625 11.25 3.78125L14 6.5V10H2Z",
    fill: "currentcolor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortrait);
export default __webpack_public_path__ + "static/media/portrait.c1e891d60ef59d60a6383d0439e70eef.svg";
export { ForwardRef as ReactComponent };